<template>
    <div ref="project" class="case-study-project relative">
        <div ref="titleContainer" class="case-study-project__title-container relative max-w-3xl mx-auto z-20">
            <h2 ref="title" class="case-study-project__name font-coign-bold text-7xl md:text-15xl tracking-semiwide uppercase whitespace-no-wrap leading-none">{{ project.caseStudyProject }}</h2>
        </div>

        <div ref="components" class="case-study-project__components">
            <template v-for="(block, index) in project.caseStudyBody">
                <intersect @enter.once="intersectHandler" :rootMargin="'0px 0px '+ intersectTrigger +'px 0px'" :key="'block'+index">
                    <div class="case-study-project__block-container">
                        <component ref="block" v-bind:is="components[block.__typename]" :key="block.__typename + project.caseStudyProject + index"  :block="block" class="case-study-project__block mt-14 md:mt-42"></component>
                    </div>
                </intersect>
            </template>
        </div>
    </div>
</template>

<script>
    import { TweenMax, Expo } from 'gsap';
    import CaseStudyStandardImage from './CaseStudyStandardImage';
    import CaseStudyThreeImages from './CaseStudyThreeImages';
    import CaseStudyTwoImagesBigSmall from "./CaseStudyTwoImagesBigSmall";
    import CaseStudyTwoEqualImages from "./CaseStudyTwoEqualImages";
    import CaseStudyImageFullWidth from "./CaseStudyImageFullWidth";
    import CaseStudyVideo from "./CaseStudyVideo";
    import CaseStudyFourImages from "./CaseStudyFourImages";
    import CaseStudyCarousel from "./CaseStudyCarousel";
    import Intersect from "vue-intersect/src";

    export default {
        name : 'case-study-project',

        components: {Intersect},

        props : {
            project : {
                type : Object,
                default : () => {}
            }
        },

        data(){
            return {
                height : 0,

                components : {
                    "CaseStudyBodyStandardImage" : CaseStudyStandardImage,
                    "CaseStudyBodyThreeImages" : CaseStudyThreeImages,
                    "CaseStudyBodyTwoImagesBigSaml" : CaseStudyTwoImagesBigSmall,
                    "CaseStudyBodyTwoEqualsImages" : CaseStudyTwoEqualImages,
                    "CaseStudyImagesTwoEqualsImages" : CaseStudyTwoEqualImages,
                    "CaseStudyBodyImageFull" : CaseStudyImageFullWidth,
                    "CaseStudyBodyVideo" : CaseStudyVideo,
                    "CaseStudyBodyFourImages" : CaseStudyFourImages,
                    "CaseStudyBodyCarousel" : CaseStudyCarousel,
                }
            }
        },

        computed : {
            top(){
                return this.$refs.title.getBoundingClientRect().top;
            },

            intersectTrigger(){
                return -(window.innerHeight /2);
            }
        },

        mounted(){
            window.addEventListener('scroll', this.scrollHandler);
            this.scrollHandler();
        },

        beforeDestroy(){
            window.removeEventListener('scroll', this.scrollHandler);
        },

        methods : {
            scrollHandler(){
                var wh = window.innerHeight;
                var scrolltop = window.pageYOffset;
                var top = this.$refs.project.offsetTop;
                var bottom = top + this.$refs.components.clientHeight;
                var bottomTrigger = scrolltop + wh;

                if(scrolltop + wh/2 > top + this.$refs.title.clientWidth / 2 && bottomTrigger < bottom) {
                    TweenMax.set(this.$refs.titleContainer, {
                        y: scrolltop - top + wh / 2 - this.$refs.title.clientWidth / 2
                    });
                }
            },

            intersectHandler(pIntersect) {
                this.showBlock(pIntersect[0].target);
            },

            showBlock(pTarget){
                console.log('COUCOU');

                TweenMax.fromTo(pTarget, 0.7, {
                    opacity : 0,
                    y : 100
                }, {
                    opacity : 1,
                    y : 0,
                    ease : Expo.easeInOut
                });
            }
        }
    }
</script>

<style lang="scss">
    @import "../assets/styles/_globals.scss";

    .case-study-project {
        &__name {
            position : absolute;
            top : 0;
            left : 100%;
            line-height : 0.8;
            transform-origin: top left;
            transform : rotate(-90deg);

            @media (min-width : 767px) {
                transform : rotate(-90deg) translateY(-50%) translateX(-100%);
            }
        }

        &__block-container{
            opacity : 0;
        }
    }
</style>